/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 1140, // min width in pixels
  menu_toggle: '.menu-toggle' // selector for toggle
});

/**
 * Close moblie menu by clicking off canvas
 */

var off_canvas = document.getElementById('close-menu');
if (off_canvas) {
  off_canvas.addEventListener('click', function() {
    var toggle = document.getElementById('menu-toggle');
    if (toggle) {
      toggle.click();
    }
  });
}

/**
 * Responsive videos
 */
fitvids();


// add jquery as dependency in functions.php and uncomment the following if you need jquery
//
// (function($) {
//   $(document).ready(function(){
//
//   });
// })(jQuery);

/**
 * Header search focus
 */
var search_input = document.getElementById('search-top-input');
var search_form  = document.getElementById('search-top');
if (search_input && search_form) {
  search_input.onblur = function() {
    search_form.classList.remove('search-form--focus');
  };
  search_input.onfocus = function() {
    search_form.classList.add('search-form--focus');
  };
}



/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    // current <img> element
    var el = e.target;
    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Sets label text to bold when corresponding input field is in focus,
 * removes bold when blurred
 */

var inputFieldList = document.querySelectorAll('.gform_body input, .gform_body textarea');

function onFocusBold() {
    var parent = this.parentNode;
    while(parent.tagName !== 'LI') {
      parent = parent.parentNode;
    }
    parent.firstChild.classList.add('bold-on-focus'); // The label of the input field (not the sublabels in complex fields)
}
function onBlurNormal() {
    var parent = this.parentElement;
    while(parent.tagName !== 'LI') {
      parent = parent.parentElement;
    }
    parent.firstChild.classList.remove('bold-on-focus');
}

for (var i = 0; i < inputFieldList.length; i++) {
  inputFieldList[i].onfocus = onFocusBold;
  inputFieldList[i].onblur = onBlurNormal;
}
